import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Navbar from './components/Navbar';
import Notification from './components/Notification';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Batches from './pages/Batches';
import Staff from './pages/Staff';
import Students from './pages/Students';
import Attendance from './pages/Attendance';
import Materials from './pages/Materials';
import Exams from './pages/Exams';
import Backup from './pages/Backup';

const ImpersonationBanner = () => {
  const { impersonating, stopImpersonation } = useApp();
  const navigate = useNavigate();
  if (!impersonating) return null;

  return (
    <div className="impersonation-banner">
      <span className="impersonation-banner-label">VIEWING AS</span>
      <span><strong>{impersonating.name}</strong> · {impersonating.role.charAt(0).toUpperCase() + impersonating.role.slice(1)}</span>
      <button
        type="button"
        className="impersonation-banner-exit"
        onClick={() => {
          stopImpersonation();
          navigate('/');
        }}
      >
        Exit
      </button>
    </div>
  );
};

const Shell = ({ children }) => {
  const { authLoading } = useApp();
  if (authLoading) return <div className="page-loading">Loading…</div>;
  return (
    <>
      <Navbar />
      <ImpersonationBanner />
      <Notification />
      <main>{children}</main>
    </>
  );
};

const App = () => (
  <AppProvider>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Shell>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route
            path="/batches"
            element={
              <ProtectedRoute roles={['teacher', 'admin']}>
                <Batches />
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff"
            element={
              <ProtectedRoute roles={['admin']}>
                <Staff />
              </ProtectedRoute>
            }
          />
          <Route
            path="/students"
            element={
              <ProtectedRoute roles={['admin']}>
                <Students />
              </ProtectedRoute>
            }
          />
          <Route path="/attendance" element={<ProtectedRoute><Attendance /></ProtectedRoute>} />
          <Route path="/materials" element={<ProtectedRoute><Materials /></ProtectedRoute>} />
          <Route path="/exams" element={<ProtectedRoute><Exams /></ProtectedRoute>} />
          <Route
            path="/backup"
            element={
              <ProtectedRoute roles={['admin']}>
                <Backup />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Shell>
    </BrowserRouter>
  </AppProvider>
);

export default App;
